<template>
  <div id="catalogProducts" class="products">
    <div v-if="!topPage" class="fixed bottom-4 right-4 cursor-pointer hidden md:block" @click.prevent="scrollToTop">
      <ArrowUpCircleIcon
        class="h-5 md:h-7 lg:h-7 w-5 md:w-7 lg:w-7 inline-block text-pdsPrimaryColor cursor-pointer"
        aria-hidden="true"
      />
    </div>
    <div class="grid grid-rows md:grid-cols-2 gap-4">
      <transition-group class="flex-1 m-0 p-0 list-none" tag="ul" name="transition-up-down">
        <v-product
          v-for="baseProduct in firstColumn"
          :key="baseProduct.baseProductId"
          :base-product="baseProduct"
          class="flex-grow mb-4"
          :favorite-selected="favoriteSelected"
          :favorite-BundleIds="favoriteBundleIds"
          @reload-search="loadSearch"
        />
      </transition-group>
      <transition-group class="flex-1 m-0 p-0 list-none" tag="ul" name="transition-up-down">
        <v-product
          v-for="baseProduct in secondColumn"
          :key="baseProduct.baseProductId"
          :base-product="baseProduct"
          class="flex-grow mb-4"
          :favorite-selected="favoriteSelected"
          :favorite-BundleIds="favoriteBundleIds"
          @reload-search="loadSearch"
        />
      </transition-group>
    </div>
  </div>
</template>

<script>
import VProduct from './Product';
import { ArrowUpCircleIcon } from '@heroicons/vue/20/solid';
export default {
  name: 'VProducts',
  components: {
    VProduct,
    ArrowUpCircleIcon
  },
  props: {
    baseProducts: {
      type: Array,
      default: () => []
    },
    favoriteSelected: {
      type: Boolean,
      default: false
    },
    favoriteBundleIds: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      bottom: false,
      topPage: false
    };
  },
  computed: {
    computedArray() {
      return this.baseProducts;
    },
    firstColumn() {
      return this.computedArray.slice(0, Math.ceil(this.computedArray.length / 2));
    },
    secondColumn() {
      return this.computedArray.slice(Math.ceil(this.computedArray.length / 2));
    }
  },
  watch: {
    bottom(bottom) {
      if (bottom) {
        this.$emit('loadMore');
      }
    }
  },
  created() {
    window.addEventListener('scroll', () => {
      this.bottom = this.bottomVisible();
      this.topPage = this.topVisible();
    });
  },
  methods: {
    topVisible() {
      const scrollY = window.scrollY || document.documentElement.scrollTop;
      return scrollY === 0;
    },
    bottomVisible() {
      const scrollY = window.scrollY || document.documentElement.scrollTop;
      const visible = document.documentElement.clientHeight;
      const pageHeight = document.documentElement.scrollHeight;
      const bottomOfPage = Math.ceil(visible + scrollY) >= Math.ceil(pageHeight);
      return bottomOfPage;
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    loadSearch() {
      this.$emit('reloadSearch');
    }
  }
};
</script>
